// Search language belongs to discovery, never to event payloads or user storage beyond the directory view.
export const toolSearchAliases: Record<string, string[]> = {
  "quick-page": [
    "作业拼图",
    "作业排版",
    "照片打印",
    "图片排版",
    "微信截图打印",
    "A3 打印",
    "学生资料",
    "图文混排",
  ],
  "pdf-pages": [
    "合并 PDF",
    "拆分 PDF",
    "旋转 PDF",
    "删除 PDF 页面",
    "抽取页面",
    "调整页序",
  ],
  "pdf-compress": [
    "压缩 PDF",
    "PDF 瘦身",
    "PDF 压小",
    "缩小 PDF",
    "减小 PDF 体积",
  ],
  "pdf-security": [
    "PDF 加密码",
    "PDF 上锁",
    "PDF 去密码",
    "PDF 解密",
    "PDF 保护",
    "PDF 权限",
  ],
  "pdf-privacy": [
    "PDF 打码",
    "PDF 涂黑",
    "PDF 遮盖",
    "删除敏感信息",
    "安全脱敏",
  ],
  "pdf-form-filler": [
    "填写 PDF",
    "PDF 填表",
    "可填写表格",
    "AcroForm",
    "PDF 表单展平",
  ],
  "pdf-create": ["PDF 加文字", "PDF 添加图片", "PDF 加水印", "图片转 PDF"],
  "pdf-toc": ["PDF 目录", "PDF 书签", "PDF 导航"],
  "pdf-to-image": ["PDF 导出图片", "PDF 转 JPG", "PDF 转 PNG"],
  "pdf-text": ["提取 PDF 文字", "复制 PDF 文字", "PDF 取字"],
  ocr: [
    "扫描件识字",
    "图片转文字",
    "识别文字",
    "图片取字",
    "扫描 PDF 文字",
    "文字识别",
  ],
  "image-compress": [
    "压缩图片",
    "缩小照片",
    "照片压小",
    "图片瘦身",
    "减小图片体积",
  ],
  "image-convert": [
    "图片改尺寸",
    "调整照片大小",
    "照片加水印",
    "图片改格式",
    "裁切图片",
  ],
  "image-annotate": [
    "图片打码",
    "图片画箭头",
    "图片遮挡",
    "图片马赛克",
    "图片加文字",
  ],
  "office-viewer": [
    "打开 Word",
    "打开 DOCX",
    "打开 PPT",
    "文档预览",
    "幻灯片查看",
  ],
  "document-version-diff": ["比较文档", "文档差异", "文件内容对比"],
  "document-metadata": ["删除作者", "清除文档属性", "Office 隐私", "PDF 作者"],
  "docx-revisions": [
    "Word 批注",
    "Word 修订",
    "DOCX 批注",
    "修订记录",
    "文档修改痕迹",
  ],
  "pdf-preflight": [
    "PDF 页面大小",
    "PDF 纸张尺寸",
    "PDF 印前",
    "MediaBox",
    "CropBox",
    "出血裁切",
  ],
  "pdf-poster": [
    "PDF 海报",
    "大图分页打印",
    "PDF 拼接打印",
    "一页分多页",
    "海报分割",
  ],
  encryption: [
    "AES 加密",
    "文件加密",
    "文本加密",
    "密码解密",
    "SM2",
    "SM3",
    "SM4",
    "国密",
    "HMAC",
    "RSA 证书",
  ],
  "password-hash": [
    "密码哈希",
    "bcrypt",
    "Argon2",
    "scrypt",
    "PBKDF2",
    "密码散列",
  ],
  "jwe-workbench": ["JWE", "加密 Token", "加密令牌", "JOSE", "A256GCM"],
  "hkdf-workbench": ["HKDF", "密钥派生", "RFC 5869", "extract expand"],
  "jwt-decoder": ["JWT", "解析 Token", "令牌验签", "JWT 签名"],
  "byte-hex": ["十六进制", "字节转换", "Hex 转文字", "UTF8 字节"],
  "modbus-frame": [
    "Modbus",
    "RTU",
    "工业协议",
    "寄存器报文",
    "串口报文",
    "CRC16",
  ],
  "mqtt-packet": ["MQTT 报文", "MQTT 数据包", "MQTT 解码", "物联网协议"],
  "dns-packet": ["DNS 报文", "DNS 解码", "域名报文", "DNS wire"],
  "protobuf-wire": [
    "Protobuf",
    "Protocol Buffers",
    "PB 解码",
    "proto 报文",
    "Varint",
  ],
  "cbor-inspector": ["CBOR", "RFC 8949", "二进制序列化"],
  "msgpack-inspector": ["MessagePack", "MsgPack", "二进制序列化"],
  "asn1-inspector": ["ASN1", "ASN.1", "DER", "证书结构", "TLV"],
  "pcap-inspector": [
    "PCAP",
    "抓包文件",
    "Wireshark",
    "TCP 数据包",
    "UDP 数据包",
    "以太网报文",
  ],
  "binary-struct": [
    "二进制结构",
    "结构体解析",
    "大小端",
    "自定义协议",
    "传感器数据",
  ],
  "riff-inspector": ["WAV 文件头", "RIFF", "WAVE", "音频容器", "音频格式检查"],
  "audio-spectrum": [
    "音频频谱",
    "频谱图",
    "声音频率",
    "FFT",
    "声谱图",
    "频率分析",
  ],
  "industry-barcode": ["EAN-13", "ISBN", "DataMatrix", "行业条码"],
  "media-studio": [
    "视频转码",
    "视频裁剪",
    "音频转码",
    "视频提取音频",
    "视频静音",
    "音视频压缩",
    "FFmpeg",
  ],
  "video-to-gif": ["视频转 GIF", "视频截取", "提取音频"],
  "audio-workbench": [
    "音频合并",
    "音频拼接",
    "声音变大",
    "音量调整",
    "音频淡入淡出",
  ],
  "subtitle-converter": [
    "字幕转换",
    "字幕时间轴",
    "SRT",
    "VTT",
    "ASS",
    "字幕偏移",
  ],
  "mqtt-client": ["MQTT 客户端", "MQTT 连接", "MQTT 订阅", "消息发布"],
  "api-request": ["接口调试", "HTTP 请求", "API 测试", "Postman", "curl 请求"],
  "har-viewer": ["HAR", "网络请求记录", "浏览器网络分析", "请求耗时"],
  "table-cleaner": ["表格去重", "Excel 清洗", "CSV 整理", "删除空行"],
  "table-pivot": ["交叉表", "数据透视", "按组汇总", "透视表"],
  "arithmetic-sheet": ["口算打印", "口算题", "数学练习", "小学生练习"],
  "tracing-sheet": ["练字纸", "描红打印", "田字格写字", "汉字练习"],
};

export function normalizeSearch(value: string): string {
  return value
    .normalize("NFKC")
    .toLocaleLowerCase()
    .replace(/(?:帮我|我想|我要|请问|如何|怎么|在线工具|工具网站|一下)/g, " ")
    .trim();
}
export function searchTokens(value: string): string[] {
  return (
    normalizeSearch(value).match(
      /[\p{Script=Han}]+|[a-z\d]+(?:[.+#-][a-z\d]+)*/gu,
    ) || []
  );
}
